import { type ContentAttribute, type Maybe } from '../graphql/graphql';
import snakeKeysToCamel from './snakeKeysToCamel';

function attributesArrayToProps<P>(
  attributes: Array<Maybe<ContentAttribute>> = []
) {
  const props = new Map<string, unknown>();

  let i = 0;
  const len = attributes.length;
  while (i < len) {
    const keyValuePair = attributes[i];
    if (keyValuePair !== null) {
      // 👉 future developers, DO NOT mutate the key or value here.
      // Instead, do that sort of "business logic" in raven-server.
      const { key, value } = keyValuePair;
      props.set(key, value);
    }
    i++;
  }

  const newProps = snakeKeysToCamel(Object.fromEntries(props));

  // treat newProps['MetaData'] as special circumstance.
  const { MetaData, ...retVal } = newProps;
  return retVal as P;
}

export default attributesArrayToProps;
